<template>
  <div class="main__wrapper">
    <div class="main__panel main__panel-left">
      <conversations-history :theme="theme" />
    </div>
    <template v-if="activeConversationHistory">
      <div class="main__panel main__panel-center">
        <chat-history />
      </div>
      <div class="main__panel main__panel-right">
        <profile />
      </div>
    </template>
    <div v-else class="main__panel main__panel-center">
      <chat-empty />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    ChatHistory: () => import('@/components/history/ChatHistory.vue'),
    ChatEmpty: () => import('@/components/ChatEmpty.vue'),
    ConversationsHistory: () => import('@/components/history/ConversationsHistory.vue'),
    Profile: () => import('@/components/history/Profile.vue'),
  },
  computed: {
    ...mapGetters([
      'activeConversationHistory',
      'theme',
    ]),
  },
};
</script>
